import React, { useState,useRef } from "react";
import styles from "./InflationCalculator.module.css";
import html2canvas from "html2canvas";
import { FaFilePdf } from "react-icons/fa";
import jsPDF from "jspdf";
import PdfLayout from "./PDF/Layout";
import ResultCard from "./InflationCalculatorResult";
const InflationCalculator = () => {
  const [monthlyExp, setMonthlyExp] = useState("");
  const [inflation, setInflation] = useState("");
  const [presentAge, setPresentAge] = useState("");
  const [retirementAge, setRetirementAge] = useState("");
  const [results, setResults] = useState(null);
  const [error, setError] = useState("");
  const pdfRef = useRef(null);
  const handleDownloadPdf = async () => {
      
        const element = pdfRef.current;

        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#ffffff",
        });

        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // fit image into one page (both width + height constraints)
        let imgWidth = pageWidth;
        let imgHeight = (canvas.height * imgWidth) / canvas.width;

        // if image is too tall, scale it down to fit page height
        if (imgHeight > pageHeight) {
          const scaleFactor = pageHeight / imgHeight;
          imgWidth = imgWidth * scaleFactor;
          imgHeight = pageHeight;
        }

        const x = (pageWidth - imgWidth) / 2; // optional center alignment
        const y = 0;

        pdf.addImage(imgData, "PNG", x, y, imgWidth, imgHeight);

        pdf.save("INFLATION-CALCULATOR-REPORT.pdf");
  };

  const formatIndianNumber = (num) => {
    return Number(num).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const calculateInflation = () => {
    setError("");
    setResults(null);

    if (!monthlyExp || !inflation || !presentAge || !retirementAge) {
      setError("Please fill in all fields.");
      return;
    }

    const mExp = parseFloat(monthlyExp);
    const inf = parseFloat(inflation);
    const pAge = parseFloat(presentAge);
    const rAge = parseFloat(retirementAge);

    if (mExp <= 0 || inf < 0 || pAge < 0 || rAge <= pAge) {
      setError("Please enter valid positive values and ensure retirement age > present age.");
      return;
    }

    const yearsToRetirement = rAge - pAge;
    const futureMonthlyExpense = mExp * Math.pow(1 + inf / 100, yearsToRetirement);
    const yearlyExpense = futureMonthlyExpense * 12;
    const retirementCorpus = yearlyExpense * 20;
    const retirementCorpusCrores = retirementCorpus / 10000000;

    const data = {
      annualExpenditure: mExp * 12,
      yearsToRetirement,
      futureMonthlyExpense,
      yearlyExpense,
      retirementCorpus,
      retirementCorpusCrores,
    };

    setResults(data);
  };

  return (
    <div className={styles.container}>
      
      <div className={styles.card}>

        <h1 className={styles.title}>Inflation Calculator</h1>

        <div className={styles.inputGroup}>
          
          <div>
            <label>Monthly Expenditure - Present</label>
            <input
              type="number"
              value={monthlyExp}
              onChange={(e) => setMonthlyExp(e.target.value)}
              placeholder="e.g. 250000"
            />
          </div>
          <div>
            <label>Inflation (%)</label>
            <input
              type="number"
              value={inflation}
              onChange={(e) => setInflation(e.target.value)}
              placeholder="e.g. 12"
            />
          </div>
          
          <div>
            <label>Present Age</label>
            <input
              type="number"
              value={presentAge}
              onChange={(e) => setPresentAge(e.target.value)}
              placeholder="e.g. 30"
            />
          </div>
          
          <div>
            <label>Retirement Age</label>
            <input
              type="number"
              value={retirementAge}
              onChange={(e) => setRetirementAge(e.target.value)}
              placeholder="e.g. 40"
            />
          </div>
        </div>
          
        <div className={styles.buttonWrapper}>
          <button type="submit" onClick={calculateInflation}>Calculate</button>
        </div>

        {error && <p className={styles.error}>{error}</p>}
        
        {results  && (
          <>
          <div className={styles.cardHeader}  >
                <div
                  className={styles.pdfButton}
                  onClick={handleDownloadPdf}
                  title="Download PDF"
                >
                    Export <FaFilePdf size={20} color="#d32f2f" />
                </div>
          </div>
          <ResultCard results={results} />
          </>  
         )}

        {results  && (
          <PdfLayout ref={pdfRef} 
              type="inflation"   
              form={{
              monthlyExp,
              inflation,
              presentAge,
              retirementAge,
              }} 
              resultCard={results}   >
          </PdfLayout>
          )}

      </div>

    </div>
  );
};

export default InflationCalculator;
